// extracted by mini-css-extract-plugin
module.exports = {"BooksOutlineButton":"BooksOutlineButton_BooksOutlineButton__ZQ1tM","isSmall":"BooksOutlineButton_isSmall__14TRw"};